export default "__VITE_ASSET__nWrjKHds__"